'use client';
import { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '@/_config/env';

export const useSearch = (query, delay = 350) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const abortRef = useRef(null);

    useEffect(() => {
        const q = query?.trim();
        if (!q || q.length < 2) {
            setData(null);
            setLoading(false);
            return;
        }

        setLoading(true);
        const timer = setTimeout(async () => {
            abortRef.current?.abort();
            abortRef.current = new AbortController();
            try {
                const res = await fetch(`${API_BASE_URL}/search?q=${encodeURIComponent(q)}`, {
                    signal: abortRef.current.signal,
                });
                const json = await res.json();
                setData(json.success ? json : null);
            } catch (e) {
                if (e.name !== 'AbortError') setData(null);
            } finally {
                setLoading(false);
            }
        }, delay);

        return () => {
            clearTimeout(timer);
            abortRef.current?.abort();
        };
    }, [query, delay]);

    return { data, loading };
};
